import e from"../ownerDocument/ownerDocument.js";function o(o){return e(o).defaultView||window}export{o as default};
//# sourceMappingURL=ownerWindow.js.map
